<template>
    <div>
        <label :for="id" class="label text-left"><strong>{{labelText}}</strong></label>
        <div class="input-group mb-3" style="margin-bottom: 0 !important">
            <b-form-select :id="id" :value="value" @change.native="$emit('change', $event.target.value ? $event.target.value : null)" :options="options" @input.native="$emit('input', $event.target.value ? $event.target.value : null)" :required="required" :disabled="disabled"/>
            <div class="input-group-append" v-if="required || (allowedValues.indexOf(value) > -1 && value)">
                <span class="input-group-text" v-bind:class="(allowedValues.indexOf(value) > -1 && value) ? 'text-success' : ''" v-b-tooltip.hover :title="tooltipTitle">
                    <font-awesome-icon style="margin: auto" :icon="(allowedValues.indexOf(value) > -1 && value) ? 'check' : 'exclamation'"/>
                </span>
            </div>
        </div>
        <ConditionBar :value="value"/>
    </div>
</template>

<script>
import ConditionBar from './ConditionBar';

export default {
    name: "FormSelect",
    components: {
        ConditionBar
    },
    props: {
        labelText: String,
        options: {type: Array, required: true},
        allowedValues: {type: Array, required: true},
        value: {default: undefined},
        inputType: {type: String, default: 'text'},
        required: {type: Boolean, default: false},
        tooltipTitle: String,
        disabled: Boolean
    },
    data() {
        return {
            id: Date.now() + '-' + Math.random().toString(36).substring(7),
            grayColor: "rgba(0,0,0,0.15)",
            colorMap: {
                1: '#bd4141',
                2: '#deb6b6',
                3: '#c7b90d',
                4: 'yellowgreen',
                5: '#329a32'
            }
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.label {
    font-size: 0.8em;
    display: block;
    margin: 0;
    margin-left: 10px;
}
.input-group-text {
    width: 45px;
}
</style>